module.exports = __webpack_public_path__ + "img/wycx.8bf393dc.png";